import { Flex } from "@chakra-ui/react";
import logo from "../../assets/images/logo.png";
import Button from "../Button/Button";
import CSS from "./styles.module.css";

const Header = ({ hasPromotion }) => {
	return (
		<Flex
			align="center"
			justifyContent="center"
			bgColor="var(--BGMain)"
			px="25px"
			py="15px"
			width="100%"
			className={hasPromotion ? CSS.HeaderPromotion : ""}
		>
			<div className={`${CSS.Header}`}>
				<div className={CSS.LogoContainer}>
					<a href="https://recooty.com">
						<img src={logo} alt="Recooty Logo" className={CSS.Logo} />
					</a>
				</div>
				<div className={CSS.PHContainer}></div>
				<div className={CSS.Buttons}>
					<Button
						className={CSS.OutlinedBtn}
						onClick={() => {
							window.Calendly.initPopupWidget({
								url: "https://calendly.com/recooty/zoom-meeting?hide_event_type_details=1&hide_gdpr_banner=1",
							});
							return false;
						}}
					>
						Book a free demo
					</Button>
					<a href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Fdash.recooty.com%2F">
						<Button className={CSS.SecondaryBtn}>Post a Free Job</Button>
					</a>
				</div>
			</div>
		</Flex>
	);
};

export default Header;
